module.exports = __webpack_public_path__ + "img/car_9.cd79dac3.jpeg";